import InsuranceReportTypes from './insurance-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchInsuranceDetailResponse: null,
	fetchInsuranceExportDetailResponse: null,
	fetchInsuranceDetailArr: [],
};

const insuranceReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/****************  GET INSURANCE REPORT START ********************** */
		case InsuranceReportTypes.FETCH_INSURANCE_REPORT_SUCCESS:
			return {
				...state,
				fetchInsuranceDetailResponse: action.payload,
				fetchInsuranceDetailArr: docodeHexResponse(
					action.payload,
					'GetInsuranceReportDetailsKey',
				),
			};

		case InsuranceReportTypes.FETCH_INSURANCE_REPORT_FAILURE:
			return { ...state, fetchInsuranceDetailResponse: action.payload };

		case InsuranceReportTypes.FETCH_INSURANCE_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchInsuranceDetailResponse: null };

		/**************** GET INSURANCE REPORT END ***************** */
		default:
			return state;
	}
};

export default insuranceReportReducer;
